import { Unit } from '@data/unit/Unit';

export const doesUnitHaveOpenTime = (unit: Unit) => {
	return !unit.officeOpenTimeDisabled && unit.openTimeConfig;
};
